import request from '../utils/request'; // 导入接口域名列表
import axios from '../utils/http'; // 导入http中创建的axios实例

const news = {    
    // news    
    newsList () {        
        return axios.get(`${request.baseUrl}/news.json`);    
    },    
}

export default news;


// WEBPACK FOOTER //
// ./src/api/news.js